import { SignatureElement } from "./PdfElements";

// todo: refactor to svg for better scaling on resize
export const PdfSignature = ({ signature }: { signature: SignatureElement }) => {
    return <img className="pointer-events-none w-full h-full object-fill object-center" src={signature.value} alt="" />;
};
